import React from 'react';
import { Box, Typography } from '@mui/material';
import { ModifiedIndicatorProps } from './types';

export const ModifiedIndicator: React.FC<ModifiedIndicatorProps> = ({
  isModified,
  value,
  tooltip = 'Manually modified',
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    {isModified && (
      <Typography
        component="span"
        sx={{ color: 'warning.main', fontWeight: 'bold' }}
        title={tooltip}
      >
        *
      </Typography>
    )}
    {value}
  </Box>
);
